if (!customElements.get('aveyra-card-colours')) {
  customElements.define('aveyra-card-colours', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.card = this.closest('.card-wrapper');
      this.image = this.card?.querySelector('.card__media img');
      if (!this.image) return;
      this.buttons = [...this.querySelectorAll('button')];
      this.original = { src: this.image.getAttribute('src'), srcset: this.image.getAttribute('srcset'), alt: this.image.alt };
      this.selected = this.querySelector('[aria-pressed="true"]');
      this.version = 0;
      this.committed = false;
      this.hover = matchMedia('(hover: hover) and (pointer: fine)');
      this.buttons.forEach(button => {
        button.addEventListener('pointerenter', () => { if (this.hover.matches) this.preview(button); }, options);
        button.addEventListener('focus', () => this.preview(button), options);
        button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          this.selected = button;
          this.committed = true;
          this.buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          this.card.querySelectorAll('.card__heading a, .aveyra-card-colours__more').forEach(link => { link.href = button.dataset.variantUrl; });
          this.card.querySelectorAll('modal-opener [data-product-url]').forEach(opener => { opener.dataset.productUrl = button.dataset.variantUrl; });
          this.preview(button);
        }, options);
      });
      this.addEventListener('pointerleave', () => this.restore(), options);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.restore(); }, options);
    }
    preview(button) {
      const version = ++this.version;
      const preload = new Image();
      preload.onload = () => {
        if (!this.isConnected || version !== this.version) return;
        this.image.srcset = button.dataset.imageSrcset;
        this.image.src = button.dataset.image;
        this.image.alt = button.dataset.imageAlt;
        this.card.classList.add('is-colour-preview');
      };
      preload.src = button.dataset.image;
    }
    restore() {
      if (this.committed && this.selected) { this.preview(this.selected); return; }
      ++this.version;
      this.image.setAttribute('src', this.original.src);
      if (this.original.srcset) this.image.setAttribute('srcset', this.original.srcset);
      this.image.alt = this.original.alt;
      this.card.classList.remove('is-colour-preview');
    }
    disconnectedCallback() { this.abort?.abort(); ++this.version; }
  });
}
